// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { endChallenge } from '../../apis/challenge';
import { endChallengeActions } from '../actionCreators/endChallengeActions';
import { RootAction } from '../rootActionCreator';

const outputActions = {
  success: endChallengeActions.success,
  failure: endChallengeActions.failure
};

type RequestActionTypes = ActionType<
  typeof endChallengeActions.request
>;
type OutputActionTypes = ActionType<typeof outputActions>;

export const endChallengeEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(endChallengeActions.request)
    ),
    switchMap((action: RequestActionTypes) => {
      // prepare api params
      const { id, callback } = action.payload;
      // send api promise
      return endChallenge(id)
        .then((response: any) => {
          // handle success case here
          return endChallengeActions.success('');
        })
        .catch((error: AxiosError) => {
          // handle error case here
          return endChallengeActions.failure({ error });
        })
        .finally(() => callback && callback())
    })
  );
};
